import React, { FC } from 'react'
import { SensorListFilters } from 'src/components'
import { SensorColumnsDataGrid } from 'src/components/columns/sensor'
import { Sensor } from 'src/api'
import { SensorFilters } from 'src/enums'
import { CommonSensorList } from '../commonSensorsList'

const columns = [
  SensorColumnsDataGrid.Id(),
  SensorColumnsDataGrid.Model,
  SensorColumnsDataGrid.DevEUI,
  SensorColumnsDataGrid.Label,
  SensorColumnsDataGrid.LastActiveContractor,
  SensorColumnsDataGrid.LastPing,
  SensorColumnsDataGrid.BatteryLevel,
  SensorColumnsDataGrid.DateConnected,
  SensorColumnsDataGrid.TimeOnProject,
  SensorColumnsDataGrid.UsedAt,
  SensorColumnsDataGrid.City,
  SensorColumnsDataGrid.Project
]

interface InUseLoRaWanSensorListProps {
  isLoading: boolean
  count: number
  data: Sensor[]
}

export const InUseLoRaWanSensorList: FC<InUseLoRaWanSensorListProps> = ({ data, isLoading, count }) => {
  return (
    <CommonSensorList
      columns={columns}
      count={count}
      data={data}
      isLoading={isLoading}
      filters={<SensorListFilters activeFilters={[SensorFilters.LowBattery, SensorFilters.WeakSignal, SensorFilters.LastPingMoreThanHour]} />}
    />
  )
}
